import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SessionService} from "../../../shared/services/session.service";
import {AlertPopupService} from "../../../shared/services/alert-popup.service";
import {Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {RegexEnum} from "../../../core/enums/regex.enum";
import {CustomerDoRegister, ForgotPassword} from "../../../states/auth/auth.actions";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
	public form: FormGroup;

	constructor(
		private sessionService: SessionService,
		private alertPopupService: AlertPopupService,
		private router: Router,
		private formBuilder: FormBuilder,
		private store: Store,
	) {
	}

	ngOnInit(): void {
		this.subscribeToSession();
		this.initializeForm();
	}

	subscribeToSession() {
		if (this.sessionService.state?.profile) {
			this.router.navigate(['']);
			this.alertPopupService.showWarningAlert('You already have an active session!!!');
		}
	}

	initializeForm(): void {
		this.form = this.formBuilder.group({
			emailId: ['', [Validators.required, Validators.email]],
		});
	}

	public markTouchedAndDirty(value: string | boolean, key: string, form : FormGroup): void {
		form.controls[key].markAsTouched();
		if (!value) {
			form.controls[key].markAsDirty();
		}
	}

	public onSubmit(form: FormGroup): void {
		try {
			if (form.valid) {
				this.store.dispatch(new ForgotPassword(form.value));
			} else {
				form.markAllAsTouched();
				throw 'You missed to fill some required fields.';
			}
		} catch (e) {
			this.alertPopupService.showErrorAlert(`${e}`);
		}
	}
}
